module.exports = __webpack_public_path__ + "static/media/medicine-drug.40312218.png";